<script>
/**
 * COMPONENTE PRINCIPAL DE DATAGRID
 * @propiedad {String}      order    Variable reactiva de nombre del campo activo en el ordenamiento
 * @propiedad {String}      dir      Variable reactiva de la dirección del ordenamiento [ASC|DESC]
 * @evento    {Function}    on:order Evento que se activa al ordenar
 * 
 * @ejemplo variables
 *      let orderField='codigo_usuario';
 *      let orderDir='ASC';
 * 
 * @ejemplo Function Evento
 * 
 * 	function orderTable(event) 
 *  {
 *      orderField=event.detail.order;
 *      orderDir=event.detail.dir;
 *  }
 * 
 * @ejemplo 
 * <Datagrid order={orderField} dir={orderDir} on:order={orderTable}>
 *      <svelte:fragment slot="header">
 *          <DatagridTitle width='100px' order="codigo_usuario" title='Código'/>
 *      </svelte:fragment>
 *      <svelte:fragment slot="body">
 *          {#each datagrid as item}
 *              <DatagridRow>
 *                  <DatagridCell title='Código'>{item.codigo_usuario}</DatagridCell>
 *                  <DatagridCell align='right'>
 *                      <button type="button" on:click|stopPropagation={()=>edit(item.codigo_usuario)} class="btn btn-danger btn-sm"><i class="bi bi-pencil-square me-1"></i>Editar</button>
 *                  </DatagridCell>
 *              </DatagridRow>
 *          {/each}
 *      </svelte:fragment>
 * </Datagrid>
 */  

    import { datagrid } from './Datagrid.js';
    import { uniqueid } from './../scripts.js';
    import { onDestroy,setContext,onMount,createEventDispatcher } from 'svelte';
    import {breakpoint, platform} from './MediaQuery.svelte'

    export let uid=false
    export let order=false
    export let dir='ASC'
    export let hideCheckbox=false
    export let hideBotonera=false
    let indexOrder=false;
    let titleOrder='';
    let montado=false;

    const dispatch = createEventDispatcher();

    uid=uniqueid();
    $datagrid={ [uid]:{order:order,dir:dir,titles:[]},...$datagrid }

    onMount(() => {
        if(indexOrder!==false)
        {
            indexOrder = $datagrid[uid].titles.findIndex( s => s.order == order )
            titleOrder=$datagrid[uid].titles[indexOrder].name;
        }
        montado=true;
	});

    setContext('uid', uid);

    
    $: if($datagrid[uid].order || $datagrid[uid].dir) {
        dispatch('order', {
	 		order: $datagrid[uid].order,
            dir: $datagrid[uid].dir,
	 	});

        if(montado===true)
        {
            if(indexOrder!==false)
            {
                indexOrder = $datagrid[uid].titles.findIndex( s => s.order == order )
                titleOrder=$datagrid[uid].titles[indexOrder].name;
            }
        }
    }

	onDestroy(() => {
        delete $datagrid[uid];
	});

</script>

<!-- svelte-ignore a11y-missing-attribute -->
{#if hideBotonera===true}
    {#if order!==false}
        <div class="btn-group float-end mb-1">
            <button class="btn btn-light btn-sm2 dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">

                {#if $datagrid[uid].dir=='ASC'}
                        <i class="bi bi-sort-down"></i>
                {:else}
                        <i class="bi bi-sort-up-alt"></i>
                {/if}
            
            </button>
            <ul class="dropdown-menu">
                {#if montado===true}
                    {#each $datagrid[uid].titles as item}
                        <li><a class="dropdown-item" on:click={()=>{$datagrid[uid].dir='ASC';$datagrid[uid].order=item.order;}}>Ordenar <strong>{item.name} Ascendiente</strong></a></li>
                        <li><a class="dropdown-item" on:click={()=>{$datagrid[uid].dir='DESC';$datagrid[uid].order=item.order;}}>Ordenar <strong>{item.name} Descendiente</strong></a></li>
                    {/each}
                {/if}        
            </ul>
        </div>
    {/if}

    <div class='float-end mb-1'>
        <slot name='botonera'/>
    </div>
    <div class="clearfix"></div>
{/if}


{#if $breakpoint=='xs' || $breakpoint=='sm' || $breakpoint=='md'}
    <slot name='header'/>
    <slot name='body'/>
{:else}
    <table class='table table-striped table-sm'>
        <thead>
            <tr class='bg-dark text-light'>
                {#if hideCheckbox===false}<td style='width:30px'></td>{/if}
                <slot name='header'/>
            </tr>
        </thead>
        <tbody>
            <slot name='body'/>
        </tbody>
    </table>
{/if}



